import React, { Fragment } from 'react';
//import { CUSTOM_MESSAGES, LABEL } from '@constants';
// react-qr-reader is not compatible with react 18 commented for temparary
import QrReader from 'react-qr-scanner';
import cn from 'classnames';
import Button from '../Button';

const QrScanComp = ({
  handleError,
  handleScan,
  code,
  sensorReg,
  setScanCode,
  // constraints,
}) => (
  <Fragment>
    <div className={cn('col-12')}>
      <div className="mt-2 fs-16 text-center fw-600">
        {/* {CUSTOM_MESSAGES.QR_CODE_MESSAGE} */}
      </div>
    </div>
    <div className={cn('d-flex mt-2 flex-column col-lg-4 offset-lg-4 col-sm-12 col-md-6 offset-md-3')}>
      <QrReader
        delay={300}
        onError={handleError}
        onScan={handleScan}
        constraints={{
          video: {
            facingMode: { ideal: 'environment' } // Set facingMode to environment for back camera
          }
        }}
        style={{ width: '100%' }}
      />
    </div>
    {code && (
      <div className={cn('d-flex flex-column col-lg-6 offset-lg-3 col-sm-12 col-md-6 offset-md-3')}>
        <div className="px-3 mt-2 fs-26 text-center fw-600">
          Code: {code}
        </div>
      </div>
    )}
    {sensorReg && code && (
      <div className={cn('row justify-content-center align-items-center mx-0 col-lg-4 offset-lg-4 col-sm-12 col-md-6 offset-md-3 mb-60 mt-10')}>
        <Button type="button" onClick={() => { sensorReg({ externalId: code }); setScanCode(null); }} className="btn btn-primary od-btn-primary btnWidth-200">
          <Fragment></Fragment><Fragment />
          <Fragment>loading</Fragment><Fragment />
        </Button>
      </div>
    )}
  </Fragment>
);

export default QrScanComp;
